import { createSelector } from "@reduxjs/toolkit";
import { getSaviorById, getSaviorByNameTitle } from "../../functions/getSaviorFunctions";
import { getArcanaById } from "../../functions/getArcanaFunctions";
import { loadData } from "../../functions/dataLoader";
import GACHA_DATA from "../../config/gacha.json";
import { selectArcanaEntities } from "./arcanaSelectors";
import { selectSaviorEntities } from "./saviorSelectors";

// let originSaviorData;
// let originArcanaData;
// let GACHA_DATA = getData("gacha.json");

// loadData("saviors.json").then((data) => (originSaviorData = data));
// loadData("arcanas.json").then((data) => (originArcanaData = data));
// loadData("gacha.json").then((data) => (GACHA_DATA = data));

const COSMIC_ATTR = ["질서", "혼돈"];

const selectLang = (state) => state.lang;

export const selectGachaState = (state) => state.gacha;

export const selectSaviorGacha = (state) => selectGachaState(state).savior;

export const selectArcanaGacha = (state) => selectGachaState(state).arcana;

export const selectSnipeGacha = (state) => selectGachaState(state).snipe;

export const selectIsPickup = (state) => selectGachaState(state).isPickup;

export const selectPickupHasCosmic = (state) => selectGachaState(state).pickupHasCosmic;

export const selectSaviorPickupType = (state) => selectGachaState(state).saviorPickupType;

export const selectSaviorCommonTargetList = createSelector([selectLang, selectSaviorEntities], (lang, saviorEntities) => {
    return Object.values(saviorEntities)
        .filter((savior) => !GACHA_DATA.NOT_IN_SAVIOR_COMMONS.includes(savior.id) && !GACHA_DATA.SAVIOR_PICKUPS.includes(savior.id))
        .sort((a, b) => a.name[lang.value].localeCompare(b.name[lang.value], lang.value))
        .map((savior) => `${savior.name[lang.value]}(${savior.title[lang.value]})`);
});

export const selectSaviorPickupTargetList = createSelector([selectLang], (lang) => {
    return GACHA_DATA.SAVIOR_PICKUPS.map((id) => {
        const savior = getSaviorById(id);
        return `${savior.name[lang.value]}(${savior.title[lang.value]})`;
    });
});

export const selectArcanaCommonTargetList = createSelector([selectLang, selectArcanaEntities], (lang, arcanaEntities) => {
    return Object.values(arcanaEntities)
        .filter(
            (arcana) =>
                !GACHA_DATA.NOT_IN_ARCANA_COMMONS.includes(arcana.id) &&
                !GACHA_DATA.ARCANA_PICKUPS.includes(arcana.id) &&
                arcana.rarity !== "R",
        )
        .map((arcana) => arcana.name[lang.value]);
});

export const selectArcanaPickupTargetList = createSelector([selectLang, selectArcanaEntities], (lang, arcanaEntities) => {
    return GACHA_DATA.ARCANA_PICKUPS.map((id) => arcanaEntities[id].name[lang.value]);
});

export const selectSnipeTargetList = createSelector(
    [
        selectSnipeGacha,
        selectIsPickup,
        selectSaviorPickupTargetList,
        selectArcanaPickupTargetList,
        selectSaviorCommonTargetList,
        selectArcanaCommonTargetList,
    ],
    (snipe, isPickup, saviorPickupTargetList, arcanaPickupTargetList, saviorCommonTargetList, arcanaCommonTargetList) => {
        if (snipe.type.value === "savior") {
            return isPickup ? saviorPickupTargetList : saviorCommonTargetList;
        } else {
            return isPickup ? arcanaPickupTargetList : arcanaCommonTargetList;
        }
    },
);

export const selectCurrentSnipeTarget = createSelector([selectSnipeGacha, selectSnipeTargetList], (snipe, targetList) => {
    if (!snipe.target && targetList.length > 0) {
        return targetList[0];
    }
    return snipe.target || "";
});

export const selectSnipeTargetCosmicType = createSelector([selectSnipeGacha], (snipe) => {
    if (snipe.type.value === "savior") {
        const target = getSaviorByNameTitle(snipe.target);
        return target && COSMIC_ATTR.includes(target.attr) ? "cosmic" : "not_cosmic";
    }
    return "not_cosmic";
});
